export const columns = [
  {
    title: 'Punto de venta',
    name: 'pointOfSaleName'
  },
  {
    title: 'Categoría',
    name: 'categoryName'
  },
  {
    title: 'zona geográfica',
    name: 'geographicLocationName'
  }
];

export const mapData = data =>
  data.map(datum => {
    return {
      id: datum.id,
      pointOfSaleId: datum.pointOfSale.id,
      pointOfSaleName: datum.pointOfSale.name,
      categoryId: datum.category.id,
      categoryName: datum.category.name,
      geographicLocationId: datum.geographicLocation.id,
      geographicLocationName: datum.geographicLocation.description
    };
  });
